import React from "react";
import "../../styles/nimbly2.css";
import FSGoogleMapLoader from "./fs_maploader";

const FSMapPage = () => {
    return (
        <div className="map-container">
            <FSGoogleMapLoader />
        </div>
    );
};

export default FSMapPage;
